import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Printer } from 'lucide-react';
import { BrandKitContent, useBrandFonts } from './BrandKitPage';
import './brandkit.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/brand-kit`;

export default function PublicBrandKitPage() {
  const { token } = useParams();
  const [state, setState] = useState('loading');
  useBrandFonts();
  useEffect(() => {
    document.title = 'AudiNexa — Brand Kit';
    axios.get(`${API}/${encodeURIComponent(token)}`).then(() => setState('ok')).catch(() => setState('off'));
  }, [token]);

  if (state === 'loading') return <div className="bk-root" data-testid="public-brandkit-loading" />;
  if (state === 'off') {
    return (
      <div className="bk-root bk-off" data-testid="public-brandkit-unavailable">
        <img src="/brand/kit/audinexa-logo-primary.svg" alt="AudiNexa" />
        <h1>This link is no longer active</h1>
        <p>Please ask the AudiNexa team for a new Brand Kit link.</p>
      </div>
    );
  }
  return (
    <div className="bk-root" data-testid="public-brand-kit-page">
      <header className="bk-toolbar">
        <span className="bk-muted-title">AudiNexa Brand Kit</span>
        <button type="button" className="bk-btn" onClick={() => window.print()} data-testid="public-brandkit-print-btn">
          <Printer size={15} /> Print
        </button>
      </header>
      <BrandKitContent />
    </div>
  );
}
